import React from 'react';
import SiteHeader from '../components/SiteHeader';
import './StaticPage.css';

const PrivacyPage: React.FC = () => {
  return (
    <>
      <SiteHeader />
      <div className="static-page">
        <div className="container">
          <p className="eyebrow">Rechtliches</p>
          <h1>Datenschutzerklärung</h1>

          <h2>Verantwortlicher</h2>
          <p>
            Hoog & Rudorf GbR
            <br />
            Seestraße 17, 83700 Rottach-Egern
            <br />
            Telefon: 0 80 22 / 57 59
            <br />
            vertreten durch die Gesellschafter: Luis Rudorf und Jannik Hoog
          </p>

          <h2>Überblick</h2>
          <p>
            Diese Plattform ist ein geschlossenes Händler-Portal (B2B). Es gibt kein öffentliches
            Tracking, keine Werbung und keine Zahlungsabwicklung.
          </p>

          <h2>Hosting</h2>
          <p>
            Die Anwendung wird von uns selbst betrieben/gehostet. Es erfolgt keine Weitergabe zu
            Marketingzwecken.
          </p>

          <h2>Zwecke und Datenkategorien</h2>
          <ul>
            <li>Login &amp; Kontoverwaltung (Benutzername, Passwort-Hash, E-Mail für Kontoanlage).</li>
            <li>
              Bestellungen (Kontakt-/Adressdaten bei Kundenlieferung, interne Auftragsreferenzen,
              optionale Uploads für Aufträge).
            </li>
            <li>
              Technische Bereitstellung &amp; Sicherheit (Server-Logs mit IP-Adresse, Zeitstempel,
              User-Agent, angefragte URL).
            </li>
          </ul>

          <h2>Gesundheitsdaten (Sehstärken und Brillenpass)</h2>
          <p>
            Im Rahmen von Bestellungen verarbeiten wir die für die Fertigung der optischen
            Einsätze erforderlichen Korrektionswerte (z.&nbsp;B. Sphäre, Zylinder, Achse) sowie
            optional hochgeladene Fotos des Brillenpasses. Dabei handelt es sich um
            Gesundheitsdaten im Sinne von Art. 9 DSGVO. Die Verarbeitung erfolgt ausschließlich
            zur Auftragserfüllung auf Grundlage von Art. 9 Abs. 2 lit. a DSGVO (Einwilligung der
            betroffenen Person, eingeholt durch den bestellenden Fachhändler) in Verbindung mit
            Art. 6 Abs. 1 lit. b DSGVO. Der bestellende Händler ist verpflichtet, die
            Einwilligung seiner Endkunden vor Übermittlung einzuholen. Die Daten werden nicht zu
            anderen Zwecken verwendet und nicht an Dritte weitergegeben.
          </p>

          <h2>Cookies und lokale Speicherung</h2>
          <p>
            Wir verwenden keine Tracking-Cookies. Nach dem Login im Händler-Portal wird ein
            Anmelde-Token im lokalen Speicher (localStorage) Ihres Browsers abgelegt. Dieses ist
            für die Funktion des Portals technisch erforderlich (§&nbsp;25 Abs. 2 Nr. 2 TDDDG) und
            wird beim Abmelden gelöscht. Ein Einwilligungsbanner ist daher nicht erforderlich.
          </p>

          <h2>Rechtsgrundlagen</h2>
          <ul>
            <li>
              Vertragserfüllung bzw. vorvertragliche Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO) für
              Portal- und Bestellfunktionen.
            </li>
            <li>
              Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) für Sicherheit, Stabilität und
              Missbrauchserkennung.
            </li>
            <li>
              Einwilligung (Art. 9 Abs. 2 lit. a DSGVO) für die Verarbeitung von
              Korrektionswerten und Brillenpass-Uploads.
            </li>
          </ul>

          <h2>Empfänger</h2>
          <p>
            Interne Verarbeitung und ggf. technische Dienstleister im Rahmen der
            Auftragsverarbeitung (keine Weitergabe an Dritte zu Werbezwecken).
          </p>

          <h2>Karten (OpenStreetMap)</h2>
          <p>
            Für die Händlerkarte verwenden wir OpenStreetMap-Kartenkacheln. Beim Laden werden
            technisch bedingt IP-Adresse und Browserdaten an die Server von OpenStreetMap (OSMF)
            übertragen. Es erfolgt kein Tracking und keine Speicherung durch uns. Rechtsgrundlage:
            berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) an der Bereitstellung der
            Kartenfunktion.
          </p>

          <h2>Speicherdauer</h2>
          <p>
            Bestell- und Vertragsdaten gemäß gesetzlichen Aufbewahrungsfristen; Logdaten in der
            Regel kurzzeitig zur Störungsbehebung. Brillenpass-Uploads werden nach Abschluss der
            Fertigung nicht länger aufbewahrt, als es für Gewährleistung und Nachbestellung
            erforderlich ist.
          </p>

          <h2>Ihre Rechte</h2>
          <p>
            Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit sowie
            Widerspruch gegen Verarbeitung auf Basis berechtigter Interessen. Eine erteilte
            Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen. Beschwerden
            bei der zuständigen Aufsichtsbehörde (Bayerisches Landesamt für Datenschutzaufsicht)
            sind möglich.
          </p>

          <h2>Kontakt</h2>
          <p>Für Datenschutz-Anfragen wenden Sie sich bitte an die oben genannte Adresse.</p>

          <p className="static-page-stand">Stand: Juli 2026</p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPage;
